export default __webpack_public_path__ + "static/media/denied.ed48b411.svg";